import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Art of cool",
  "description": "",
  "published": "2007-02-26T00:00:00.000Z",
  "redirect_from": ["/blog/art-of-cool/swizec/281"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Someone (I won't say it was metron) notified me today via a lovely PM that `}<a parentName="p" {...{
        "href": "http://www.marctauss.com/flash.html"
      }}>{`Marc Tauss`}</a>{` a.k.a metron has a new `}<a parentName="p" {...{
        "href": "http://www.marctauss.com/flash.html"
      }}>{`website`}</a>{` with his, if I can be the judge, amazingly awesome art. It features his photo illustrations, a style I've always adored, and apparently some other stuff. You should check it out.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      